import React, { useState, useEffect, useContext } from 'react';
import BookerContext from '../../context/bookerContext';
import { ReactComponent as ApplePayDarkIcon } from '../../assets/img/apple-pay-icon-gray.svg';
import { ReactComponent as PayPalIcon } from '../../assets/img/paypal-icon.svg';
import { ReactComponent as StarIcon } from '../../assets/img/star.svg';
import FetchService from '../../services/fetchService';
import urlService from '../../services/urlService';
import Loader from '../Loader';
import { updatePaymentDescription } from '../../utils/updatePaymentDescription';
import '../../assets/styles/error.sass';
import { ReactComponent as ApplePayIcon } from '../../assets/img/apple-pay-icon.svg';
import { ReactComponent as CardIcon } from '../../assets/img/card-number-icon.svg';

const PaymentList = () => {
  const context = useContext(BookerContext);
  const {
    state: {
      payment,
      paymentMethodId,
      paymentListId,
      oneTimePaymentId,
      selectedFleet,
      applePayPaymentMethod,
      payPalPaymentMethod,
    },
    updatePaymentMethodId,
    updatePayment,
    updateApplePayPaymentMethod,
    updatePayPalPaymentMethod,
    updateOneTimePaymentId,
    updatePaymentListId,
  } = context;

  const [paymentPersonalMethods, setPaymentPersonalMethods] = useState([]);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const isApplePay = window.ApplePaySession;

  const isPayPalInPaymentArray = paymentPersonalMethods.filter(item => item.type === 'paypal')[0];
  const isApplePayInPaymentArray = paymentPersonalMethods.filter(item => item.type === 'apple_pay')[0];
  const paymentWebList = [
    {
      id: 'applePay',
      icon: <ApplePayIcon />,
      label: '',
      visible: window.ApplePaySession && !isApplePayInPaymentArray,
    },
    {
      id: 'card',
      icon: <CardIcon />,
      label: 'Credit Card',
      visible: false,
    },
    {
      id: 'payPal',
      icon: <PayPalIcon />,
      label: '',
      visible: !isPayPalInPaymentArray,
    },
  ];

  const isListVisible = paymentWebList.find(p => p.visible);

  useEffect(() => {
    loadPayments();
  }, []);

  const loadPayments = () => {
    return FetchService.getWebApiResource(urlService.loadPaymentsUsingProviderId(selectedFleet.id))
      .then(response => {
        if (response && response.length && !isApplePay) {
          response = response.filter(item => item.type !== 'apple_pay');
        }

        let newArray = [];

        const isApplePayInArray = response.filter(item => item.type === 'apple_pay')[0];
        const isPayPalInArray = response.filter(item => item.type === 'paypal')[0];
        const isCardInArray = response.filter(item => item.id === paymentMethodId)[0];
        const isDefaultCardInArray = response.find(item => item.type === 'credit_card' && item.default);

        if (!paymentMethodId || !paymentMethodId.toString()) {
          if (paymentListId === 'applePay') {
            if (isApplePayInArray) {
              isApplePayInArray.default = !isDefaultCardInArray;
            } else {
              const payApplePay = {
                default: !isDefaultCardInArray,
                type: 'apple_pay',
                description: 'Apple Pay',
              };

              response.forEach(obj => (obj.default = false));
              newArray = [payApplePay].concat(response);
            }
          } else if (paymentListId === 'payPal') {
            if (isPayPalInArray) {
              isPayPalInArray.default = !isDefaultCardInArray;
            } else {
              const payPayPal = {
                default: !isDefaultCardInArray,
                type: 'paypal',
                description: 'PayPal',
              };

              response.forEach(obj => (obj.default = false));
              newArray = [payPayPal].concat(response);
            }
          } else {
            const defaultPayment = newArray.filter(item => item.default)[0];
            updatePaymentMethodId(defaultPayment?.id);
            updatePayment(defaultPayment);
          }
        }

        if (isApplePayInArray) {
          updateApplePayPaymentMethod(isApplePayInArray.id);
        } else if (isPayPalInArray) {
          updatePayPalPaymentMethod(isPayPalInArray.id);
        } else if (!isCardInArray && payment.type) {
          if (!newArray.length) newArray = response;
          if (!newArray.find(item => item.id === payment.id)) newArray = [payment].concat(newArray);
        }

        if (!newArray.length) newArray = response;
        newArray.sort((a, b) => (a.id > b.id ? 1 : -1));
        if (!newArray?.find(item => item.default)) newArray[0].default = true;

        setPaymentPersonalMethods(newArray);
        setIsIframeLoaded(true);
        console.log('Payments have been successfully loaded ', newArray);
      })
      .catch(error => {
        setIsIframeLoaded(true);
        console.log('Add payments invalid ', error);
      });
  };

  const onPaymentChooseHandler = (e, paymentObj) => {
    const { id, type } = paymentObj;

    // const idNumber = parseInt(id.split('-')[1]);
    updatePaymentMethodId(id);
    updateOneTimePaymentId(null);
    updatePaymentListId(type);

    const payment = paymentPersonalMethods.filter(item => (item.id ? item.id === id : item.type === type))[0];
    payment.description = updatePaymentDescription(payment);
    updatePayment(payment);
  };

  const getCardType = brand => {
    if (brand === 'Other' || !brand) {
      return 'none';
    }

    let splittedBrand = brand.split(' ')[0];
    return splittedBrand.toLowerCase();
  };

  const onOnePaymentHandler = e => {
    const {
      target: { id },
    } = e;
    updateOneTimePaymentId(id);
    // updatePaymentListId(id);
  };

  const isCheckedPayment = item => {
    if (oneTimePaymentId) return false;
    if (paymentMethodId || paymentMethodId === 0) return paymentMethodId === item.id;
    // if (paymentListId) return paymentListId.toLowerCase() === item.type;
    return item.default;
  };

  return (
    <div className="form-group form-group-paymentList">
      <div className="title">Payments</div>
      <ul className="clearfix payment-list payment-personal-list">
        {paymentPersonalMethods &&
          paymentPersonalMethods.map(item => (
            <li key={item.id} className="payment-list-item">
              <input
                type="radio"
                name="payment"
                id={`card-${item.id}`}
                checked={isCheckedPayment(item)}
                onChange={e => onPaymentChooseHandler(e, item)}
                className="payment-input"
              />
              <label className="payment-icon" htmlFor={`card-${item.id}`}>
                {item.type === 'credit_card' && (
                  <>
                    <span className={`card-icon card-type-${getCardType(item.brand)}`} />
                    <span className="card-label">
                      {item.brand} *{item.last4}
                    </span>
                  </>
                )}
                {item.type === 'apple_pay' && <ApplePayDarkIcon />}
                {item.type === 'paypal' && <PayPalIcon />}
                {item.type === 'corporate' && (
                  <>
                    <span className={`card-icon card-type-${getCardType(item.brand)}`} />
                    <span className="card-label">{item.label}</span>
                  </>
                )}
                {item.type === 'cash' && (
                  <>
                    <span className="card-icon card-type-none" />
                    <span className="card-label">{item.description}</span>
                  </>
                )}
              </label>
              {item.default && (
                <span className="default-card">
                  <StarIcon />{' '}
                </span>
              )}
            </li>
          ))}
      </ul>

      <div className="title">Add Payment Method</div>
      <div className="sub-title">To add a credit card to your account, please use the Curb app.</div>

      <ul className={`clearfix payment-list ${isListVisible ? 'borderBottom' : ''}`}>
        {paymentWebList.map(item => (
          <li
            key={item.id}
            id={`container-${item.id}`}
            className={`payment-list-item custom-payment-item ${item.visible ? '' : 'hidden'}`}
          >
            <input
              type="radio"
              name="payment-list"
              id={item.id}
              checked={oneTimePaymentId === item.id}
              onChange={onOnePaymentHandler}
              className="payment-input payment-input-list"
            />
            <label className="payment-icon" htmlFor={item.id}>
              <span className="payment-icon">
                {item.icon} {item.label}
              </span>
            </label>
          </li>
        ))}
      </ul>

      <Loader loading={!isIframeLoaded} />
    </div>
  );
};

export default PaymentList;
